module.exports = __webpack_public_path__ + "img/approved.d62e41ad.png";